export default "__VITE_ASSET__DfmYYWVy__"